import React from 'react';
import MasterLayout from '../masterLayout/MasterLayout';
import GlobalTablesLayer from '../components/GlobalTablesLayer';

const GlobalTablesPage = () => (
  <MasterLayout pageTitle='Global Reference Tables'>
    <GlobalTablesLayer />
  </MasterLayout>
);

export default GlobalTablesPage;
